<script>
  import CardLargeMolecule from '~/Components/Molecules/CardLarge'
  import CardMedMolecule from '~/Components/Molecules/CardMed'
  import CardMentorMolecule from '~/Components/Molecules/CardMentor'

  export let cards = {}
  export let cardSize = 'large'

  const components = {
    large: CardLargeMolecule,
    med: CardMedMolecule,
    mentor: CardMentorMolecule,
  }
</script>

<div class="card__collection">
  {#each cards as card, index}
    <svelte:component this={components[cardSize]} {card} {index} />
  {/each}
</div>

<style lang="scss">
  .card__collection {
    display: flex;
    flex-wrap: wrap;
  }
</style>